"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormOptionsCms = void 0;
var FormOptionsCms = /** @class */ (function () {
    function FormOptionsCms() {
        this.carrierInfoCTALabel = 'Add carrier info';
        this.addPreferredAreaCodeLabel = 'Add preferred area code';
    }
    return FormOptionsCms;
}());
exports.FormOptionsCms = FormOptionsCms;
//# sourceMappingURL=FormOptions.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/FormOptions/FormOptions.cms.js
// module id = 2001
// module chunks = 8